import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../../context/LanguageContext';
import { normalizeSupportedLanguage } from '../../../../utils/createScopedI18n';
import { companyI18n } from './i18n';

export default function BranchDeleteModal({
  Modal,
  show,
  branch,
  onClose,
  onConfirm,
}) {
  const { language } = useLanguage();
  const companyLanguage = normalizeSupportedLanguage(language);
  const { t } = useTranslation(undefined, { i18n: companyI18n });

  useEffect(() => {
    companyI18n.changeLanguage(companyLanguage);
  }, [companyLanguage]);

  return (
    <Modal
      title={t('company_delete_title')}
      show={show}
      onClose={onClose}
      primaryBtnTxt={t('company_modal_delete')}
      primaryBtnAction={onConfirm}
      secondaryBtnTxt={t('company_modal_cancel')}
      secondaryBtnAction={onClose}
      ctaAligment='right'
      width='520px'
    >
      <p className='mb-0'>
        {t('company_delete_confirmPrefix')}{' '}
        <b>{branch?.name ?? t('company_delete_defaultBranch')}</b>
        {t('company_delete_confirmSuffix')}
      </p>
    </Modal>
  );
}
